import { type PropType } from 'vue';
import { UPDATE_MODEL_VALUE } from '../../constants';

export interface UploadProps {
    modelValue: File[];
    placeholder?: string;
    multiple?: boolean;
    accept?: string;
    limit?: number;
    disabled?: boolean;
    hideButtonAfterUpload?: boolean;
    addNumbering?: boolean;
}

export const uploadProps = {
    modelValue: {
        type: Array as PropType<UploadProps['modelValue']>,
        default: () => [],
        required: true,
    },
    placeholder: {
        type: String as PropType<UploadProps['placeholder']>,
        default: 'Загрузить файл',
        required: false,
    },
    multiple: {
        type: Boolean as PropType<UploadProps['multiple']>,
        default: undefined,
        required: false,
    },
    accept: {
        type: String as PropType<UploadProps['accept']>,
        default: undefined,
        required: false,
    },
    limit: {
        type: Number as PropType<UploadProps['limit']>,
        default: undefined,
        required: false,
    },
    disabled: {
        type: Boolean as PropType<UploadProps['disabled']>,
        default: undefined,
        required: false,
    },
    hideButtonAfterUpload: {
        type: Boolean as PropType<UploadProps['hideButtonAfterUpload']>,
        default: undefined,
        required: false,
    },
    addNumbering: {
        type: Boolean as PropType<UploadProps['addNumbering']>,
        default: undefined,
        required: false,
    },
};

export const uploadEmits = {
    [UPDATE_MODEL_VALUE]: (event: File[]) => event,
    change: (event: File[]) => event,
    delete: (event: File[]) => event,
};
